import { useEffect, useState } from 'react';

/**
 * useMediaQuery
 *
 * Tracks a CSS media query in React.
 */
export function useMediaQuery(query: string) {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return;
    }

    const media = window.matchMedia(query);
    const update = () => {
      setMatches(media.matches);
    };

    update();

    media.addEventListener('change', update);
    return () => {
      media.removeEventListener('change', update);
    };
  }, [query]);

  return matches;
}
